module.exports = __webpack_public_path__ + "static/media/logo-phone-by-webcom.2b1ac2c8.svg";